import { Component } from '@angular/core';

@Component({
    selector: 'dcs-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/footer.component.ts